export const ptBRCompanyDataPageTranslation = {
  company_data: {
    header: {
      title: 'Dados da empresa',
      description:
        'Informe os dados da sua empresa para ter uma visão consolidada dos seus principais indicadores financeiros e operacionais.',
    },
    table: {
      columns: {
        annual_data: 'Dados anuais',
      },
    },
    modal_info: {
      text: 'As informações financeiras de {{id}} precisam ser atualizadas!',
    },
    placeholders: {
      select_month: 'Selecione o mês...',
      input_data: 'Insira dados',
    },
    save: 'Salvar',
    sectors: {
      title: 'Informe os principais setores de atuação',
      description:
        'Informe os principais setores de atuação (máximo {{max}}) e seus respectivos percentuais. Caso não tenha dados, deixe em branco.',
      columns: {
        sector: 'Setor',
        percentage: 'Percentual',
        clear: 'Limpar',
      },
      placeholders: {
        select_sector: 'Selecione um setor',
        percentage: '0',
      },
    },
    toast: {
      save_success: 'Dados salvos com sucesso!',
      save_error: 'Erro ao salvar dados, tente novamente!',
      grade_change_validation_error:
        'Não foi possível validar mudança na estrutura de grades!',

      sectors_select_before_percentage:
        'Você precisa selecionar o setor antes de salvar o percentual.',
      sectors_invalid_percentages:
        'Percentuais inválidos. Verifique os campos.',
      sectors_sum_exceeds: 'A soma dos percentuais não pode ultrapassar 100%.',
      sectors_sum_exceeds_after_clear:
        'A soma dos percentuais ultrapassa 100%.',
      sectors_save_success: 'Setores salvos com sucesso',
      sectors_save_error: 'Falha ao salvar setores. Tente novamente.',
      sectors_load_error: 'Não foi possível carregar setores.',
    },
  },
};
